function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.4258 1.40625H8.77409C8.48378 0.587769 7.70183 0 6.78516 0C5.86848 0 5.08653 0.587769 4.79622 1.40625H2.10938C0.946198 1.40625 0 2.35245 0 3.51562V15.8906C0 17.0538 0.946198 18 2.10938 18H11.428C12.5899 17.9988 13.5352 17.0526 13.5352 15.8906V3.51562C13.5352 2.35245 12.589 1.40625 11.4258 1.40625ZM6.08203 2.8125V2.10938C6.08203 1.72169 6.39748 1.40625 6.78516 1.40625C7.17284 1.40625 7.48828 1.72169 7.48828 2.10938V2.8125H8.89453V4.18359H4.67578V2.8125H6.08203ZM12.1289 15.8906C12.1289 16.2779 11.8137 16.5933 11.4273 16.5938H2.10938C1.72169 16.5938 1.40625 16.2783 1.40625 15.8906V3.51562C1.40625 3.12794 1.72169 2.8125 2.10938 2.8125H3.26953V5.58984H10.3008V2.8125H11.4258C11.8135 2.8125 12.1289 3.12794 12.1289 3.51562V15.8906ZM9.46431 8.08731L10.5043 9.03378L6.00114 13.982L3.02673 11.105L4.00452 10.0942L5.93687 11.9633L9.46431 8.08731Z",
  fill: "#172342"
});

function SvgNewPaymentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPaymentIcon);
export default __webpack_public_path__ + "static/media/NewPaymentIcon.a9b27dd4.svg";
export { ForwardRef as ReactComponent };